// istanbul ignore file
import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import { MobileOfficeRoot } from '../../components/styles';
import { maxWidth } from '../../constants';

export const FourthColumn = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}));

export const Highlight = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  padding: theme.spacing(6, 3),
  backgroundColor: theme.palette.grey[100],
  marginBottom: theme.spacing(6),
}));

export const BottomContent = styled(MobileOfficeRoot)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(6),
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('sm')]: {
    padding: 0,
  },
}));

export const HighlightGrid = styled('div', {
  shouldForwardProp: shouldForwardProp(),
})<{ isMobileOffice?: boolean | undefined }>(({ isMobileOffice, theme }) => ({
  maxWidth,
  boxSizing: 'content-box',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: '1fr',
  columnGap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '3fr 1fr',
  },
  ...(isMobileOffice && {
    '@media (min-width: 1025px)': {
      margin: theme.spacing(0, 6),
      borderLeft: '280px solid transparent',
    },
    '@media (min-width: 1604px)': {
      margin: '0 auto',
      borderLeft: 'none',
    },
  }),
}));

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginTop: theme.spacing(6),
  background: theme.palette.common.white,
  paddingBottom: theme.spacing(9),
}));
